import React from 'react'
import { useBackgroundTasks } from '@/contexts/BackgroundTaskContext'

export const BackgroundTaskNotification: React.FC = () => {
  const { showRebuildNotification, isIndexRebuilding, rebuildProgress, rebuildMessage } = useBackgroundTasks()

  if (!showRebuildNotification || !isIndexRebuilding) {
    return null
  }

  return (
    <div className="fixed top-4 right-4 bg-blue-500 text-white px-6 py-4 rounded-lg shadow-lg z-50 max-w-sm transition-all duration-300 opacity-100 translate-y-0">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 mt-0.5">
          {/* Spinning gear icon for rebuilding */}
          <svg className="w-5 h-5 animate-spin" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium mb-2">
            Index Rebuilding
          </p>
          <p className="text-xs text-blue-100 mb-3">
            Analysis unavailable during rebuild
          </p>

          {/* Progress bar */}
          <div className="bg-blue-600 rounded-full h-2 mb-2">
            <div
              className="bg-white rounded-full h-2 transition-all duration-500"
              style={{ width: `${Math.max(0, Math.min(100, rebuildProgress * 100))}%` }}
            />
          </div>

          {/* Progress text */}
          <p className="text-xs text-blue-100">
            {rebuildMessage || `${Math.round(rebuildProgress * 100)}% complete`}
          </p>
        </div>
      </div>
    </div>
  )
}